import { AllHtmlEntities } from "html-entities";

const boxes = [9472, 9580];
const misc = [9728, 9981];
const wingbats = [9985, 10175];
const arrows = [8592, 8703];

export default () => {
  const temp = [
    "•",
    "☀",
    "☂",
    "★",
    "☆",
    "→",
    "►",
    "⭐",
    "❤️",
    "♨️",
    "✈️",
    "☀️",
    "☁️",
    "❄️",
    "✂️",
    "▶️",
    "©️",
    "®️",
    "™️",
    "♻️",
    "〽️",
    "◻️",
    "◼️",
    "⚠️",
    "⚪",
    "⚫",
    "⏳",
    "▲",
    "⇔",
    "↵",
    "♥",
    "◊",
    "♦",
    "☏",
    "☐",
    "☑",
    "☒"
  ];
  for (let i = wingbats[0]; i <= wingbats[1]; i++) {
    temp.push(AllHtmlEntities.decode(`&#${i};`));
  }
  for (let i = misc[0]; i <= misc[1]; i++) {
    temp.push(AllHtmlEntities.decode(`&#${i};`));
  }
  for (let i = arrows[0]; i <= arrows[1]; i++) {
    temp.push(AllHtmlEntities.decode(`&#${i};`));
  }
  for (let i = boxes[0]; i <= boxes[1]; i++) {
    temp.push(AllHtmlEntities.decode(`&#${i};`));
  }
  return temp;
};



// WEBPACK FOOTER //
// ./src/components/emoji.js